import { defineMessages } from "react-intl";

export const scope = "pages.MemberPlatformBalanceCurrencyPage";

export const messages = defineMessages({
  title: {
    id: `${scope}.title`,
    defaultMessage: "Balance de {name} en {currency}",
  },
  lastMovements: {
    id: `${scope}.lastMovements`,
    defaultMessage: "Últimos movimientos",
  },
  totalLabel: {
    id: `${scope}.totalLabel`,
    defaultMessage: "Total",
  },
  sendButton: {
    id: `${scope}.sendButton`,
    defaultMessage: "ENVIAR",
  },
  receiveButton: {
    id: `${scope}.receiveButton`,
    defaultMessage: "RECIBIR",
  },
  investDisabled: {
    id: `${scope}.investDisabled`,
    defaultMessage: "GANAR {tna}% TNA",
  },
  investmentDetails: {
    id: `${scope}.investmentDetails`,
    defaultMessage: "DETALLES DE INVERSIÓN",
  },
  sellButton: {
    id: `${scope}.sellButton`,
    defaultMessage: "VENDER",
  },
  buyButton: {
    id: `${scope}.buyButton`,
    defaultMessage: "COMPRAR",
  },
  investmentNotificationTitle: {
    id: `${scope}.investmentNotificationTitle`,
    defaultMessage: "Ayer podrías haber generado {ars} ARS",
  },
  investmentNotificationMessage: {
    id: `${scope}.investmentNotificationMessage`,
    defaultMessage: "¡Activá ya la inversión e invertí al {tea}% TEA!",
  },
  goBack: {
    id: `${scope}.goBack`,
    defaultMessage: "VOLVER",
  },
  linkText: {
    id: `${scope}.linkText`,
    defaultMessage: "Para más información visita nuestros",
  },
  link: {
    id: `${scope}.link`,
    defaultMessage: "Términos y condiciones",
  },
  pendingLable: {
    id: `${scope}.pendingLable`,
    defaultMessage: "INVIRTIENDO...",
  },
});
